import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface UpdateBillingPlanParams {
  planId: string;
  params: {
    name: string;
    ranges: Array<{
      minMinute: number;
      maxMinute: number;
      flatRate: number;
    }>;
  };
}

export const updateBillingPlan = async ({
  planId,
  params,
}: UpdateBillingPlanParams) => {
  const response = await baseAPI.put<unknown>(
    `hourly-tuition-billing/${planId}`,
    {
      ...params,
    },
  );
  return response;
};

export const useUpdateBillingPlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateBillingPlan,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.HOURLY_TUITION_BILLING],
      });
    },
  });
};
